import {
  getPresignedUrlRequest,
  type PresignedUrlBody,
} from "../../requests/aws/s3";

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "image/svg+xml",
] as const;
const MAX_SIZE_BYTES = 2 * 1024 * 1024; // 2 MB

const extensionByMime: Record<string, string> = {
  "image/jpeg": ".jpg",
  "image/png": ".png",
  "image/webp": ".webp",
  "image/gif": ".gif",
  "image/svg+xml": ".svg",
};

export interface UploadResult {
  success: boolean;
  key?: string;
  error?: string;
}

export async function uploadToS3Fn(
  file: File,
  token: string,
  resourceType: "users" | "gyms" | "software",
  resourceId: string,
  assetPath?: string,
): Promise<UploadResult> {
  const type = file.type?.toLowerCase();

  if (
    !type ||
    !ALLOWED_TYPES.includes(type as (typeof ALLOWED_TYPES)[number])
  ) {
    return {
      success: false,
      error: "Formato no permitido. Use JPEG, PNG, WebP, GIF o SVG.",
    };
  }
  if (file.size > MAX_SIZE_BYTES) {
    return { success: false, error: "El archivo no debe superar los 2 MB." };
  }

  const ext = extensionByMime[type] ?? ".jpg";
  const timestamp = Date.now();
  const baseName =
    file.name.replace(/\.[^.]+$/, "").replace(/[^a-zA-Z0-9]/g, "_") || "image";
  const fileName = `${timestamp}-${baseName}${ext}`;

  try {
    const body: PresignedUrlBody = {
      fileName,
      fileType: type,
      resourceType,
      resourceId,
      ...(assetPath && { assetPath }),
    };

    const { url, key } = await getPresignedUrlRequest(body, token);

    const putResponse = await fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": type },
    });

    if (!putResponse.ok) {
      return {
        success: false,
        error: "Error al comunicar con el storage local.",
      };
    }

    return { success: true, key };
  } catch (err) {
    console.error("S3 Upload Error:", err);
    return { success: false, error: "Error inesperado en la subida." };
  }
}
